const house_initial = payload => {
  return {
    type: "houseInitial",
    payload
  };
};

export default house_initial;
